// Copyright (c) Docugami, Inc. All rights reserved.

interface KeymapEntry {
    callback: () => void;
    registrationToken: number;
}

export class KeyboardAccelerators {
    private static keymap: { [key: string]: KeymapEntry[] } = {};
    private static nextRegistrationToken = 0;
    private static disablers = new Set();

    public static onKeyPress(event: KeyboardEvent | React.KeyboardEvent<HTMLDivElement>): void {
        if (KeyboardAccelerators.disablers.size) {
            return;
        }

        const entries = KeyboardAccelerators.keymap[event.key];
        if (!!entries && entries.length > 0) {
            event.preventDefault();
            entries[0].callback();
        }
    }

    public static init(): void {
        window.addEventListener("keydown", KeyboardAccelerators.onKeyPress);
    }

    public static add(key: string, callback: () => void): number {
        const regToken = KeyboardAccelerators.nextRegistrationToken;
        KeyboardAccelerators.nextRegistrationToken++;

        let entries: KeymapEntry[] | undefined = KeyboardAccelerators.keymap[key];
        if (!entries) {
            entries = [];
            KeyboardAccelerators.keymap[key] = entries;
        }

        entries.unshift({
            callback: callback,
            registrationToken: regToken
        })

        return regToken;
    }

    public static remove(key: string, registrationToken: number) {
        const entries = KeyboardAccelerators.keymap[key];
        KeyboardAccelerators.keymap[key] = entries.filter(x => x.registrationToken !== registrationToken);
    }

    public static addOrRemoveDisabler(adding: boolean, disabler: string) {
        if (adding) {
            KeyboardAccelerators.disablers.add(disabler);
        } else {
            KeyboardAccelerators.disablers.delete(disabler);
        }
    }
}
